import CardImageFlip from "./CardImageFlip";
import slingblack1 from "../img/sling-black-1.jpg"
import slingblack2 from "../img/sling-black-2.jpg"
import slingred1 from "../img/sling-red-1.jpg"
import slingred2 from "../img/sling-red-2.jpg"
import slingtan from "../img/sling-tan.jpeg"
import slingtotetan from "../img/sling-tote-tan.jpeg"
import slingtotetanwhite from "../img/Sling-party-tan-white.jpeg"

const MasterCardImgFlipSling = () => {
    return (
        <section class="cards-section lemon-green" id="audit">
            <div class="container">
                <h2 class="section-title">Sling Bags</h2>
                <div class="cards-grid">
                    <CardImageFlip imgFront={slingred1} imgBack={slingred2} />
                    <CardImageFlip imgFront={slingblack1} imgBack={slingblack2} />
                    <CardImageFlip imgFront={slingtan} imgBack={slingtotetan} />
                    <CardImageFlip imgFront={slingtotetanwhite} imgBack={slingblack2} />
                 </div>
            </div>
        </section>
    );
}

export default MasterCardImgFlipSling;